import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const ctx = require.context(`@/pages/`, true, /model\.js$/)
const ctx2 = require.context(`@/model/`, true, /\.js$/)

const modules = {}
const namespacekeys = []
const registerModelUtil = c => {
  c.keys().forEach(key => {
    const model = c(key).default
    const { namespace } = model
    if (namespacekeys.indexOf(namespace) > -1) {
      console.error(`"${namespace}": has been register`)
      return
    }
    delete model.namespace;
    (model.namespaced = true), (modules[namespace] = model)
  })
};
[ctx, ctx2].forEach(c => registerModelUtil(c))

const store = new Vuex.Store({
  state: {
    version: '1.0.0.0'
  },
  modules
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js